export const environment = {
  production: true,
  API_URL: '/WebAPI',
  GOOGLE_INV_CAPTCH: '6LdxQ3wUAAAAABlYovyn-gVf4xQPCdMRsXskNuWZ'
};
// PARA SITIO PRD API_URL: 'https://tool.amg.la/WebAPI',
// PARA SITIO TEST 'http://tool.amg.la:8089/WebAPI'



// WEBPACK FOOTER //
// ./src/environments/environment.ts